<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="excmdailyplan_state"
        class="form-control-label">state</label>
      <input
        id="excmdailyplan_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="excmdailyplan_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="excmdailyplan_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="excmdailyplan_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="excmdailyplan_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="excmdailyplan_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="excmdailyplan_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_date"
        class="form-control-label">date</label>
      <input
        id="excmdailyplan_date"
        v-model="item.date"
        :class="['form-control', isInvalid('date') ? 'is-invalid' : '']"
        type="dateTime"
        required="true"
        placeholder=""
        @input="handleUpdateField('date', $event.target.value)">
      <div
        v-if="isInvalid('date')"
        class="invalid-feedback">{{ violations.date }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_servicemanUserData"
        class="form-control-label">servicemanUserData</label>
      <input
        id="excmdailyplan_servicemanUserData"
        v-model="item.servicemanUserData"
        :class="['form-control', isInvalid('servicemanUserData') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('servicemanUserData', $event.target.value)">
      <div
        v-if="isInvalid('servicemanUserData')"
        class="invalid-feedback">{{ violations.servicemanUserData }}</div>
    </div>
    <div class="form-group">
      <label
        for="excmdailyplan_dailyPlanItems"
        class="form-control-label">dailyPlanItems</label>
      <input
        id="excmdailyplan_dailyPlanItems"
        v-model="item.dailyPlanItems"
        :class="['form-control', isInvalid('dailyPlanItems') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('dailyPlanItems', $event.target.value)">
      <div
        v-if="isInvalid('dailyPlanItems')"
        class="invalid-feedback">{{ violations.dailyPlanItems }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
